module.exports = __webpack_public_path__ + "img/P16-zh.2a769b7b.png";